import styled from 'styled-components/macro'

export default {
  DeviceCard: styled.div`
  &&{
  }
`,
}
